module.exports = __webpack_public_path__ + "img/site_47_pb.2dc94466.png";